module.exports = __webpack_public_path__ + "static/img/logo8.133c2b8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo8.png
// module id = 1l3Z
// module chunks = 1